import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { JobEntity } from './job.entity';

/** PD-17093 — a file attached to a job (the opportunity_file pattern). */
@Index('job_file__fk_job__id', ['fkJobId'], {})
@Index('job_file__fk__file__id', ['fkFileId'], {})
@Entity('job_file')
export class JobFileEntity extends BaseEntity {
	@Column('int', { name: 'fk_job__id', unsigned: true })
	public fkJobId!: number;

	@Column('int', { name: 'fk__file__id', unsigned: true })
	public fkFileId!: number;

	@ManyToOne(() => JobEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_job__id', referencedColumnName: 'id' }])
	public job!: JobEntity;

	@ManyToOne(() => FileEntity, { onDelete: 'RESTRICT', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk__file__id', referencedColumnName: 'id' }])
	public file!: FileEntity;
}
